/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_AVAILABLE_CASE_DATA,
  SET_IS_TRANSMITTING,
} from '../actions/transmitActions';

const initialState = {
  isTransmitting: false,
  approvals: [],
  attachments: [],
  caseNotes: [],
  logs: [],
  docTitles: [],
  signedDRAIs: [],
  signedAuthForms: [],
  signedSerologies: [],
  referringorgData: null,
  coronerMEProtocols: null,
  location: '',
};

const draiReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AVAILABLE_CASE_DATA: {
      const {
        approvals,
        attachments,
        caseNotes,
        docTitles,
        signedDRAIs,
        signedSerologies,
        signedAuthForms,
        referringorgData,
        coronerMEProtocols,
        location,
      } = action.payload;

      return produce(state, (draft) => {
        draft.approvals = approvals;
        draft.attachments = attachments;
        draft.caseNotes = caseNotes;
        draft.docTitles = docTitles;
        draft.signedDRAIs = signedDRAIs;
        draft.signedAuthForms = signedAuthForms;
        draft.signedSerologies = signedSerologies;
        draft.referringorgData = referringorgData;
        draft.coronerMEProtocols = coronerMEProtocols;
        draft.location = location;
      });
    }

    case SET_IS_TRANSMITTING: {
      return produce(state, (draft) => {
        draft.isTransmitting = action.payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default draiReducer;
